import { MobileDatePicker } from "@mui/x-date-pickers";
import { memo } from "react";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { withPopover } from "shared/lib/hocs/withPopover";
import FormGroup from "../FormGroup/FormGroup";
import DatePickerActionBar from "shared/ui/DatePickerActionBar/DatePickerActionBar";

const DatePicker = function DatePicker({
  name,
  register = (name) => ({}),
  setValue = (name, any) => {},
  error = null,
  label = null,
  addon = null,
  displayAs = Form.Group,
  control = undefined,
  allowNegative = false,
  allowZero = false,
  popoverRef = (el) => ({}),
  popoverHandlers = null,
  format = "YYYY-MM-DD",
  actions = ["clear", "cancel", "accept"],
  md = 6,
  ...props
}) {
  return (
    <>
      <FormGroup
        controlId={name}
        label={label}
        addon={addon}
        error={error}
        displayAs={displayAs}
        md={md}
      >
        <Controller
          name={name}
          control={control}
          render={({ field: { ref: formRef, ...rest } }) => (
            <Form.Control
              slotProps={{
                textField: { id: name, error: !!error },
                actionBar: { actions, ...rest },
              }}
              as={MobileDatePicker}
              format={format}
              isInvalid={!!error}
              ref={(el) => {
                popoverRef(el);
                formRef(el);
              }}
              slots={{
                actionBar: DatePickerActionBar,
              }}
              {...popoverHandlers}
              {...rest}
              {...props}
            />
          )}
        />
      </FormGroup>
    </>
  );
};

DatePicker.WithPopover = withPopover(DatePicker);
export default memo(DatePicker);
